import React from 'react';
import { Card, Col, Tooltip as AntTooltip, CardProps, Typography } from 'antd';
import { formatAmount } from 'app/utils/amountFormatter';
import { InfoCircleOutlined } from '@ant-design/icons';
const { Title } = Typography;
interface ISoldeCard {
  amount: number | string;
  title: string;
  name: string;
  className?: CardProps['className'];
  lg?: boolean;
  color?: string;
}

const SoldeCard: React.FC<ISoldeCard> = ({ amount, name, title, className, lg = false, color = '#f5f5f5' }) => {
  return (
    <Col xs={24} sm={12} lg={lg ? 8 : 6}>
      <Card
        title={
          <Title style={{ color, fontWeight: 'normal' }} level={5}>
            {name}
          </Title>
        }
        bordered={false}
        className={`card ${className}`}
        extra={
          <AntTooltip title={title}>
            <InfoCircleOutlined />
          </AntTooltip>
        }
      >
        <p style={{ color, fontWeight: 'bold' }}>{formatAmount(amount)} FCFA</p>
      </Card>
    </Col>
  );
};

export default SoldeCard;
